import { Select } from "antd";
import _ from "lodash";
import moment from "moment";
import QueryString from "qs";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from "react-router-dom";
import { getSemesterMonths } from "../../api/semesters.api";
import { getExamStatsByAnswerRate, getExamStatsByClass, getExamStatsByLevel, getExamStatsByQuestion, getExamStatsByStudent, getExamStatsLevelByExamCodeList, getExamStatsSummary, getExamStatsSummaryByExamCodeList } from "../../api/statistics.api";
import { getExams, getExamSemesters, getTestTypes } from "../../api/testCenter.api";
import Button from "../../components/Button";
import ErrorResponse from "../../components/ErrorResponse";
import SimpleHeader from "../../components/layout/SimpleHeader";
import Loader from "../../components/Loader";
import ExamStatsByClass from "../../components/statistics/regular-test/ExamStatsByClass";
import ExamStatsByLevel from "../../components/statistics/regular-test/ExamStatsByLevel";
import ExamStatsByQuestion from "../../components/statistics/regular-test/ExamStatsByQuestion";
import ExamStatsByStudent from "../../components/statistics/regular-test/ExamStatsByStudent";
import ExamStatsSummary from "../../components/statistics/regular-test/ExamStatsSummary";
import MultiCampusModal from "../../components/statistics/regular-test/modals/MultiCampusModal";
import TabItem from "../../components/statistics/TabItem";
import useAxios from "../../hooks/useAxios";
import useNotification from "../../hooks/useNotification";
import config from "../../lib/config";
import { IGetSemesterMonths, ISemester } from "../../models/semesters.model";
import { IGetExamStatsByAnswerRate, IGetExamStatsByClass, IGetExamStatsByLevel, IGetExamStatsByQuestion, IGetExamStatsByStudent, IGetExamStatsSummary } from "../../models/statistics.model";
import { IGetExams, IGetExamSemesters, IGetTestTypes, ITestType } from "../../models/testCenter.model";
import { RootState } from "../../store/rootReducer";
import { getReverseYears } from "../../lib/util";
import EduStepSelect from "../../components/common/EduStepSelect";
import ExamStatsByAnswerRate from "../../components/statistics/regular-test/ExamStatsByAnswerRate";
import TableEmpty from "../../components/common/TableEmpty";
import SelectCampusMultiChoice from "../../components/SelectCampusMultiChoice";

enum Contents {
  Summary,
  Level,
  Class,
  Student,
  Question,
  AnswerRate
}

const StatisticsRegularTest = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });
  const { auth } = useSelector((state: RootState) => state.auth);
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  // SY0005 = 연도
  const SY0005 = commonCodes.find(item => item.commonCode === 'SY0005')?.detailCode;
  // PR0002 = 학기유형
  const PR0002 = commonCodes.find((item) => item.commonCode === 'PR0002')?.detailCode;
  const { infoNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetTestTypes>();
  const { data: res2, isLoading: isLoading2, error: error2, execute: execute2 } = useAxios<IGetExams>();
  const { data: res4, isLoading: isLoading4, error: error4, execute: execute4 } = useAxios<IGetExamStatsSummary>();
  const { data: res5, isLoading: isLoading5, error: error5, execute: execute5 } = useAxios<IGetExamStatsByQuestion>();
  const { data: res6, isLoading: isLoading6, error: error6, execute: execute6 } = useAxios<IGetExamSemesters>();
  const { data: res7, isLoading: isLoading7, error: error7, execute: execute7 } = useAxios<IGetSemesterMonths>();
  const { data: res8, isLoading: isLoading8, error: error8, execute: execute8 } = useAxios<IGetExamStatsByLevel>();
  const { data: res9, isLoading: isLoading9, error: error9, execute: execute9 } = useAxios<IGetExamStatsByClass>();
  const { data: res10, isLoading: isLoading10, error: error10, execute: execute10 } = useAxios<IGetExamStatsByStudent>();
  const { data: res11, isLoading: isLoading11, error: error11, execute: execute11 } = useAxios<IGetExamStatsByAnswerRate>();

  const [content, setContent] = useState<Contents>(Contents.Summary);
  const [isFirstRun, setIsFirstRun] = useState(true);

  const [params, setParams] = useState();
  const [eduStepCode, setEduStepCode] = useState<string>();
  const [examDiv, setExamDiv] = useState<string>();
  const [examTypeCode, setExamTypeCode] = useState<number>();
  const [examCode, setExamCode] = useState<number>();
  const [types, setTypes] = useState<ITestType[]>([]);
  const [year, setYear] = useState<string>();
  const [yearSemesterCode, setYearSemesterCode] = useState<number>();
  const [monthSeq, setMonthSeq] = useState<number>();

  const [semesterCode, setSemesterCode] = useState<number>();
  const [campusCodes, setCampusCodes] = useState<string[]>([]);
  const [multiCampusVisible, setMultiCampusVisible] = useState(false);
  const [gradeCode, setGradeCode] = useState<string>();
  // 탭 컨텐츠 내 페이지
  const [pageNo, setPageNo] = useState(1);
  const [examSubjectCode, setExamSubjectCode] = useState<number>();
  const [courseCode, setCourseCode] = useState<number>();
  const [selExamCodeList, setSelExamCodeList] = useState<IGetExams>();
  // 엑셀다운로드 Title
  const [excelCampusCodes, setExcelCmpusCodes] = useState<string[]>([]);
  const { campusData } = useSelector((state: RootState) => state.campusData);
  const [semesterType, setSemesterType] = useState("RG");
  const [semesterData, setSemesterData] = useState<ISemester[]>([]);

  useEffect(() => {
    execute(getTestTypes());
    execute6(getExamSemesters());

    //현재 년도
    //setYear(moment().format('YYYY'));
    defSelectBoxSetting();
  }, []);

  const defSelectBoxSetting = () => {
    //검색 필드 Default값 셋팅
    const defSelValue:any = "";
    setEduStepCode(defSelValue);
    setExamDiv(defSelValue);
    setExamTypeCode(defSelValue);
  }

  useEffect(() => {
    const defSelValue:any = "";
    setExamTypeCode(defSelValue);
    const _types = _.clone(res?.data)?.filter((item) => item.examDiv === examDiv && item.eduStepCode === eduStepCode);
    if (_types) setTypes(_types);
    else setTypes([]);
  }, [examDiv]);

  /*  학기 조회용 년도 사용 시
  useEffect(() => {
    setYearSemesterCode(undefined);
  }, [year]);
  */

  useEffect(() => {
    if (yearSemesterCode) {
      execute7(getSemesterMonths(String(yearSemesterCode)));
    }
    setMonthSeq(undefined);
  }, [yearSemesterCode]);

  useEffect(() => {
    doGetExams();
  }, [eduStepCode, examDiv, yearSemesterCode, examTypeCode, monthSeq]);

  useEffect(() => {
    const _params: any = {};

    if (query.idx) {
      _params.idx = Number(query.idx);
      setContent(_params.idx);
    }

    _params.page = _params.pageNo;
    setParams(_params);
  }, [location]);

  useEffect(() => {
    if (isFirstRun) {
      setIsFirstRun(false);
      return;
    }

    getExamStats();
  }, [content, gradeCode, pageNo, examSubjectCode, courseCode]);

  useEffect(() => {
    fnSetSemesterData(year || '', semesterType);
  }, [year]);

  useEffect(() => {
    fnSetSemesterData(year || '', semesterType);
  }, [semesterType]);

  useEffect(() => {
    fnSetSemesterData(year || '', semesterType);
  }, [res6]);

  //시험 조회(시험명 SELECT BOX Binding)
  const doGetExams = () => {
    const _params: any = {
      pageNo: 1,
      perPage: 99,
    };
    
    if(!eduStepCode || !examDiv || !year || !yearSemesterCode || !monthSeq || !examTypeCode) {
      setExamCode(undefined);
    } else {
      const defSelValue:any = "";
      setExamCode(defSelValue);
    }

    if(!year || !yearSemesterCode) {
      setExamCode(undefined);
      setSelExamCodeList(undefined);
      return false;
    }

    _params.year = year;
    _params.semesterCode = yearSemesterCode;

    if(eduStepCode) {
      _params.eduStepCode = eduStepCode;
    }

    if(examDiv) {
      _params.examDiv = [examDiv];
    } else {
      switch (eduStepCode as string) {
        case 'EM':
          _params.examDiv = ['MT', 'LT'];
          break;
        case 'MD':
          _params.examDiv = ['PL', 'LT'];
          break;
        default:
          _params.examDiv = ['MT', 'PL', 'LT'];
          break;
      }
    }

    if(examTypeCode) {
      _params.examTypeCode = examTypeCode;
    }

    if(monthSeq) {
      _params.monthSeq = monthSeq;
    }

    execute2(getExams(_params || { pageNo: 1, perPage: 99 }));
  }

  useEffect(() => {
    let _data: any = _.cloneDeep(res2);
    setSelExamCodeList(_data);
  }, [res2])

  useEffect(() => {
    //문항,스킬 탭 과목, 레벨 선택 값 초기화
    setExamSubjectCode(undefined);
    setCourseCode(undefined);
  }, [examCode])

  //검색 Data조회
  const getExamStats = (_pageNo?: number) => {

    let examCodeList = [];
    if(content === Contents.Class || content === Contents.Student || content === Contents.Question) {
      if(examCode) examCodeList.push(examCode);
    } else {
      //교육단계, 구분, 년도, 학기, 월, 유형을 선택한 경우에만 전체선택 처리 체크 예외처리
      if(eduStepCode && examDiv && year && yearSemesterCode && monthSeq && examTypeCode) {
        if(!examCode && res2?.data) {
          res2?.data.map(item => {
            examCodeList.push(item.examCode);
          });
        } else {
          if(examCode) examCodeList.push(examCode);
        }
      } else {
        if(examCode) examCodeList.push(examCode);
      }
    }

    if (examCodeList.length === 0 || !yearSemesterCode) {
      return infoNotification(t('statistics.placementTest.message1'));
    }
    
    if (_pageNo) {
      setPageNo(_pageNo);
    }

    const req: any = {
      semesterCode:yearSemesterCode,
      campusCode: auth.hqYn === 'Y'
        ? campusCodes
        : (campusCodes.length ? campusCodes : auth.campus),
      examCodeList: examCodeList
    };

    if(campusData.length === campusCodes.length) {
      setExcelCmpusCodes([]);
    } else {
      setExcelCmpusCodes(campusCodes);
    }

    switch (content) {
      case Contents.Summary:
        execute4(getExamStatsSummaryByExamCodeList(req));
        break;
      case Contents.Level:
        if (gradeCode) req.gradeCode = gradeCode;
        execute8(getExamStatsLevelByExamCodeList(req));
        break;
      case Contents.Class:
        execute9(getExamStatsByClass(examCodeList[0], req));
        break;
      case Contents.Student:
        execute10(getExamStatsByStudent(examCodeList[0], {
          ...req,
          pageNo: _pageNo || pageNo,
          perPage: config.pageSize,
        }));
        break;
      case Contents.Question:
        {
          if (!examSubjectCode) return;
          const _req: any = {
            ...req,
            examSubjectCode,
          }
          if (courseCode) _req.courseCode = courseCode;
          execute5(getExamStatsByQuestion(examCodeList[0], _req));  
        }
        break;
        case Contents.AnswerRate:
          {
            if (!examSubjectCode) return;
            const _req: any = {
              ...req,
              examSubjectCode,
            }
            if (courseCode) _req.courseCode = courseCode;
            execute11(getExamStatsByAnswerRate(examCodeList[0], _req));  
          }
          break;
    }
  };

  const fnSetSemesterData = (year : string, semesterType : string) => {
    if(res6) {
      let data: ISemester[] = _.cloneDeep(res6.data);

      if(year) {
        data = data.filter((item: any) => item.learningYearCode === year);
      }

      if(semesterType) {
        data = data.filter((item: any) => item.semesterType === semesterType);
      }

      if(data.length === 0) {
        setSemesterCode(undefined);
      }

      setSemesterData(data);
    }
  }

  const renderContent = () => {
    switch (content) {
      case Contents.Summary:
        return (
          <ExamStatsSummary
            // @ts-ignore 
            rawData={res4?.data}
            excelParam={{excelCampusCodes}}
          />
        );
      case Contents.Level:
        return (
          <ExamStatsByLevel
            // @ts-ignore 
            rawData={res8?.data}
            excelParam={{excelCampusCodes}}
            gradeCode={gradeCode}
            setGradeCode={setGradeCode}
          />
        );
      case Contents.Class:
        return (
          <ExamStatsByClass
            // @ts-ignore 
            rawData={res9?.data}
            excelParam={{excelCampusCodes}}
          />
        );
      case Contents.Student:
        return (
          <ExamStatsByStudent
            // @ts-ignore 
            rawData={res10?.data}
            // @ts-ignore 
            total={res10 ? res10?.total : 0}
            pageNo={pageNo}
            setPageNo={setPageNo}
            examCode={examCode}
            semesterCode={semesterCode}
            campusCodes={campusCodes}
            excelParam={{excelCampusCodes}}
          />
        );
      case Contents.Question:
        return (
          <ExamStatsByQuestion
            // @ts-ignore 
            data={res5?.data}
            examCode={examCode}
            semesterCode={semesterCode}
            examSubjectCode={examSubjectCode}
            setExamSubjectCode={setExamSubjectCode}
            courseCode={courseCode}
            setCourseCode={setCourseCode}
          />
        );
      case Contents.AnswerRate:
        return (
          <ExamStatsByAnswerRate
            // @ts-ignore 
            data={res11?.data}
            examCode={examCode}
            semesterCode={semesterCode}
            examSubjectCode={examSubjectCode}
            setExamSubjectCode={setExamSubjectCode}
            courseCode={courseCode}
            setCourseCode={setCourseCode}
          />
        );
    }
  };

  const onSetContent = (_content: Contents) => {
    let _params: any = {};
    if (params) {
      // @ts-ignore
      _params = { ...params, idx: _content };
    }
    history.push(`/statistics/regular-test?${QueryString.stringify(_params)}`);
  };

  return (
    <>
      <SimpleHeader
        iconFile="icon-statistics-big.svg"
        parentMenu={t('common.menu.statistics')}
        currentMenu={t('statistics.regularTest.title1')}
        onlyTitle={true}
      />
      <div className="common-search">
        <div className="search-area">
          <ul className="search-bx">
            <li>{/* 캠퍼스 */}
              <label>{t('common.menu.campus')}</label>
              <SelectCampusMultiChoice
                placeholder={t('statistics.eLearning.title2')}
                onChange={setCampusCodes}
                value={campusCodes}
              />
              <label>
                ({campusCodes.length ? `${campusCodes.length}${t('statistics.attendance.text1')}` : t('common.text.all')})
              </label>
            </li>
            <li>
              <label>{t('statistics.refund.placeholder1')}</label> {/* 연도 */}
              <Select
                placeholder={t('statistics.refund.placeholder1')}
                value={year}
                onChange={value => setYear(value)}
              >
                {getReverseYears(SY0005).map(item => (
                  <Select.Option
                    key={item.detailCode}
                    value={item.detailCode}
                  >
                    {item.korName}
                  </Select.Option>
                ))}
              </Select>            
            </li>
            <li>
              <label>
                {t('program.semester.column11')}
              </label>
              <Select
                className="w-120p"
                value={semesterType}
                onChange={value => setSemesterType(value)}
              >
                {
                  PR0002?.map(({korName: label, detailCode: value}) => {
                    return (
                      <Select.Option key={value} value={value}>
                        {label}
                      </Select.Option>
                    )
                  })
                }
              </Select>
            </li>                         
            <li>{/* 학기 */}
              <label>{t('common.column.semester')}</label>
              <Select
                placeholder={t('statistics.regularTest.placeholder2')}
                value={yearSemesterCode}
                onChange={(value, item) => {
                  setYearSemesterCode(value);

                  Object.entries(item).map(([key, value])=>{
                    if(key === 'semesterYear') {
                      setYear(value);
                    }
                  });
                }}
              >
                {semesterData?.map(item => ( 
                  <Select.Option
                    key={item.semesterCode}
                    value={item.semesterCode}
                    semesterYear={item.learningYearCode}
                  >
                    {item.semesterName}
                  </Select.Option>
                ))}
              </Select>
            </li>
            <li> {/* 월 */}
              <label>{t('statistics.placementTest.1')}</label>
              <Select
                placeholder={t('statistics.regularTest.placeholder2')}
                value={monthSeq}
                onChange={value => setMonthSeq(value)}
                disabled={!yearSemesterCode}
              >
                <Select.Option value="">{t('common.text.all')}</Select.Option>
                {res7?.data?.map(item => (
                  <Select.Option
                    key={item.monthSeq}
                    value={item.monthSeq}
                  >
                    {item.monthName}{t('payment.charge.text4')}
                  </Select.Option>
                ))}
              </Select>
            </li>
            <li> {/* 교육단계 */}
              <label>{t('common.placeholder.1')}</label>
              <EduStepSelect
                eduStepCode={eduStepCode}
                setEduStepCode={value => {
                  setEduStepCode(value);
                  setExamDiv("");
                }}
                width={90}
                includeAll
              />
            </li>
            <li>  {/* 구분 */}
              <label>{t('statistics.placementTest.column12')}</label>
              <Select
                placeholder={t('statistics.placementTest.column12')}
                value={examDiv}
                onChange={value => {
                  setExamDiv(value);
                }}
                disabled={!eduStepCode}
              >
                <Select.Option value="">
                  {t('common.text.all')}
                </Select.Option>
                <Select.Option value={eduStepCode === 'EM' ? 'MT' : 'PL'}>
                  {eduStepCode === 'EM' ? 'Monthly Test' : 'Prelim'}
                </Select.Option>
                <Select.Option value="LT">
                  Term Test
                </Select.Option>
              </Select>
            </li>
            <li>  {/* 유형 */}
              <label>{t('statistics.regularTest.placeholder1')}</label>
              <Select
                placeholder={t('statistics.regularTest.placeholder1')}
                value={examTypeCode}
                onChange={value => setExamTypeCode(value)}
                disabled={!examDiv || examDiv === 'all'}
              >
                <Select.Option value="">{t('common.text.all')}</Select.Option>
                {types.map(item => (
                  <Select.Option
                    key={item.examTypeCode}
                    value={item.examTypeCode}
                  >
                    {item.examTypeName}
                  </Select.Option>
                ))}
              </Select>
            </li>
            <li> {/* 시험명 */}
              <label>{t('class.class.column3')}</label>
              <Select
                className="w-200"
                placeholder={t('statistics.regularTest.placeholder2')}
                value={examCode}
                onChange={(value, item) => {
                  setExamCode(value);

                  Object.entries(item).map(([key, value])=>{
                    if(key === 'semesterCode') {
                      setSemesterCode(value);
                    }
                  });
                }}
              >
                {
                  (eduStepCode && examDiv && year && yearSemesterCode && monthSeq && examTypeCode)
                  && <Select.Option value="">{t('common.text.all')}</Select.Option>
                }
                {selExamCodeList?.data.map(item => (
                  <Select.Option
                    key={item.examCode}
                    value={item.examCode}
                    semesterCode={item.semesterCode}
                  >
                    {item.examName}
                  </Select.Option>
                ))}
              </Select>
              <div className="comm-btn__area">
                <Button
                  className="btn-basic small black"
                  onClick={() => getExamStats(1)}
                  text={t('common.button.search')}
                />
              </div>
            </li>
          </ul>
        </div>
        <div className="comm-bx__between">
          🏷️ {t('statistics.regularTest.msg1')}
        </div>
      </div>
      
      <div className="content scrollbar">
        <div className="col-frame">
          {(isLoading4 || isLoading5 || isLoading8 || isLoading9 || isLoading10 || isLoading11) && <Loader />}
          <ErrorResponse error={error} />
          <ErrorResponse error={error2} />
          <ErrorResponse error={error4} />
          <ErrorResponse error={error5} />
          <ErrorResponse error={error6} />
          <ErrorResponse error={error7} />
          <ErrorResponse error={error8} />
          <ErrorResponse error={error9} />
          <ErrorResponse error={error10} />
          <ErrorResponse error={error11} />

          {
            res4?.data || res8?.data || res9?.data || res10?.data || res11?.data || content === Contents.Question || content === Contents.AnswerRate
              ? (
                <>
                  <div className="comm-tab__line">
                      <ul>
                        <TabItem
                          currentContent={content}
                          onSetContent={onSetContent}
                          tabContent={Contents.Summary}
                          tabLabel={t('statistics.attendance.Tab1')}
                        />
                        <TabItem
                          currentContent={content}
                          onSetContent={onSetContent}
                          tabContent={Contents.Level}
                          tabLabel={t('statistics.regularTest.tab1')}
                        />
                        <TabItem
                          currentContent={content}
                          onSetContent={onSetContent}
                          tabContent={Contents.Class}
                          tabLabel={t('common.menu.class')}
                        />
                        <TabItem
                          currentContent={content}
                          onSetContent={onSetContent}
                          tabContent={Contents.Student}
                          tabLabel={t('common.menu.student')}
                        />
                        <TabItem
                          currentContent={content}
                          onSetContent={onSetContent}
                          tabContent={Contents.AnswerRate}
                          tabLabel={t('statistics.placementTest.tab1')}
                        />
                        <TabItem
                          currentContent={content}
                          onSetContent={onSetContent}
                          tabContent={Contents.Question}
                          tabLabel={t('statistics.regularTest.tab2')}
                        />
                      </ul>  
                  </div>
                  <div id="custom-tabs-tabContent">
                    {renderContent()}
                  </div>
                </>
                )
              : isLoading || isLoading2 || isLoading4 || isLoading5 || isLoading8 || isLoading9 || isLoading10 || isLoading11
                ? null
                : (
                  <TableEmpty text={t('statistics.appday.text1')} />
                  )
          }
        </div>
      </div>

      {multiCampusVisible &&
        <MultiCampusModal
          visible={multiCampusVisible}
          setVisible={setMultiCampusVisible}
          campusCodes={campusCodes}
          setCampusCodes={setCampusCodes}
        />
      }
    </>
  );
}

export default StatisticsRegularTest;
